// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type EntityPagesArticlesModuleContentArticleDeleteMutationVariables =
  Types.Exact<{
    input: Types.ContentDeleteArticleInput;
  }>;

export type EntityPagesArticlesModuleContentArticleDeleteMutation = {
  __typename?: 'Mutation';
  contentDeleteArticle?: {
    __typename?: 'ContentArticleDeletionResult';
    error?: {
      __typename?: 'ContentError';
      message?: string | null;
      description?: string | null;
      errors?: Array<string> | null;
    } | null;
  } | null;
};

export const EntityPagesArticlesModuleContentArticleDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'entityPagesArticlesModuleContentArticleDelete',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentDeleteArticleInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentDeleteArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPagesArticlesModuleContentArticleDeleteMutation,
  EntityPagesArticlesModuleContentArticleDeleteMutationVariables
>;
